import { useCallback, useRef, useState } from 'react'

export interface UseInViewportReturnValue<T extends HTMLElement = any> {
  inViewport: boolean
  ref: React.RefCallback<T | null>
}

export function useInViewport<T extends HTMLElement = any>(): UseInViewportReturnValue<T> {
  const observer = useRef<IntersectionObserver | null>(null)
  const [inViewport, setInViewport] = useState(false)

  const ref: React.RefCallback<T | null> = useCallback(node => {
    if (typeof IntersectionObserver !== 'undefined') {
      if (node && !observer.current) {
        observer.current = new IntersectionObserver(entries =>
          setInViewport(entries.some(entry => entry.isIntersecting)),
        )
      } else {
        observer.current?.disconnect()
      }

      if (node) {
        observer.current?.observe(node)
      } else {
        setInViewport(false)
      }
    }
  }, [])

  return { ref, inViewport }
}
